import { render, staticRenderFns } from "./mini-slot.vue?vue&type=template&id=b2706daa&"
import script from "./mini-slot.vue?vue&type=script&lang=js&"
export * from "./mini-slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports